var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kinesis-container',{staticClass:"skill-perspective",attrs:{"perspective":200}},[_c('kinesis-element',{staticClass:"skill-container",attrs:{"strength":8,"type":"depth"}},[_c('img',{attrs:{"src":_vm.getImage(_vm.img)}}),_c('p',{staticClass:"text-small"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }